export default function copyWright (year) {
    return `Ⓒ ${year}`
}